import { Box, Container, Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { API } from '../../../global/config/api';
import { useServerCall } from '../../../global/helpers/hooks';
import GlobalStore from '../../../global/stores/GlobalStore';
import { BaseHeader, XsButton } from '../../../global/ui';

function MaintenanceContainer() {
  const { t } = useTranslation();
  const history = useHistory();

  // fire-and-forget: načíta appInfo aby sa prípadne zistilo, že údržba skončila
  useServerCall<undefined, any>({
    key: 'maintenance_appInfo',
    mode: 'auto',
    request: { method: 'GET', url: API.appInfo() },
    disableServerError: true,
    queryOptions: { refetchOnWindowFocus: false }
  });

  useEffect(() => {
    return () => {
      GlobalStore.setMaintenanceDesc(null);
    };
  }, []);

  return (
    <>
      <BaseHeader />
      <Container maxWidth='md'>
        <Grid container direction='column' spacing={8} style={{ textAlign: 'center' }}>
          <Grid item>
            <Box pt={8}>
              <Typography variant='h3'>{t('maintenance.title')}</Typography>
            </Box>
          </Grid>
          <Grid item container direction='column' spacing={4}>
            <Grid item>
              {GlobalStore.maintenanceDesc && (
                <Typography variant='h6' style={{ fontWeight: 'normal' }}>
                  {GlobalStore.maintenanceDesc}
                </Typography>
              )}
            </Grid>
            <Grid item className='mt-8'>
              <XsButton
                fullWidth={false}
                label='maintenance.refresh_button'
                icon={<i className='fas fa-sync' />}
                onClick={() => history.push('/')}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default observer(MaintenanceContainer);
